import { makeVar } from '@apollo/client'

/** Demo rounds the guest session holds per mode, read when the claim is offered. */
export interface GuestDemoRounds {
  upDownAi: number
  bullseye: number
}

export const EMPTY_GUEST_DEMO_ROUNDS: GuestDemoRounds = {
  upDownAi: 0,
  bullseye: 0
}

export const guestDemoRoundsVar = makeVar<GuestDemoRounds>(
  EMPTY_GUEST_DEMO_ROUNDS
)
